__webpack_require__.p = "/cld-periodic-table/";